export default __webpack_public_path__ + "static/media/Real-Time Bluedot Wayfinding.ebf2749a.svg";